import React from "react";
import { useTranslation } from "react-i18next";
import { CrossIcon } from "@aureskonnect/react-ui";
import classnames from "classnames";
import { CustomCardHeader } from "@components/Common/CustomCardStyled";

interface Props {
    formTitle: string;
    headerTitle: string;
    onClose: () => void;
}

const InformationFormHeader = React.memo(
    ({ formTitle, headerTitle, onClose }: Props) => {
        const { t } = useTranslation();

        return (
            <CustomCardHeader
                className="d-flex align-items-center justify-content-between"
                style={{ maxHeight: "76px" }}
            >
                <h5
                    className={classnames(
                        "pt-3 mdi_txt_FRtitleFormModeOfInformation",
                        {
                            mdi_txt_FReditModeInformation:
                                formTitle === t("Modify a mode of information"),
                        }
                    )}
                >
                    {headerTitle}
                </h5>
                <CrossIcon
                    className="icon-close-notification__clz mdi_icn_FRcloseForm"
                    height={13}
                    width={13}
                    onClick={onClose}
                />
            </CustomCardHeader>
        );
    }
);

InformationFormHeader.displayName = "InformationFormHeader";
export default InformationFormHeader;
